import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { downloadPdf } from 'app/modules/cases/components/view-pdf/viewPdf.component';

@Component({
  selector: "view-pdf2",
  templateUrl: "./viewPdf2.component.html",
  styleUrls: ["./viewPdf2.component.scss"],
})
export class ViewPdfComponent2 implements OnInit {
  @Input() data;
  pdfUrl
  constructor(
    public activeModal: NgbActiveModal,
    
    ) {}
    ngOnInit() {
      this.pdfUrl = this.data
  }
  closeModal() {
    this.activeModal.dismiss();
  }
  downloadPdf() {
    downloadPdf(this.pdfUrl)
  }
}
